import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Flex, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { Project } from "../../../../../js/parsegenerated";
import { useProject } from "../../hooks/useProject";

type Props = {
  project?: Project;
  style?: React.CSSProperties;
};

export const ProjectDuedateIcon = observer((props: Props) => {
  const t = useTranslation();
  const { project, start, end, dateText, isOverdue } = useProject(
    props.project
  );
  const isFinished = project?.get("finished") ?? false;

  return (
    <Flex gap="small">
      {project?.get("finished") && (
        <Tooltip title={t("maintenance:project.finished")}>
          <Icon icon="fa:check" />
        </Tooltip>
      )}
      {(start || end) && !isFinished && (
        <Tooltip title={dateText}>
          <Icon icon="fa:solid:clock" color={props.style?.color} />
        </Tooltip>
      )}
      {isOverdue && !isFinished && (
        <Tooltip title={t("maintenance:project.overdue")}>
          <Icon icon="fa:solid:exclamation-circle" color={props.style?.color} />
        </Tooltip>
      )}
    </Flex>
  );
});
